import { DrawerWidgetComponent } from './drawer-widget.component'

export const initDrawerWidgets = (root: ParentNode = document): void => {
  const elements = Array.from(root.querySelectorAll('[data-drawer-widget-component]')) as HTMLElement[]

  elements.forEach((element) => {
    if (element.dataset.drawerWidgetInitialized === 'true') {
      return
    }

    element.dataset.drawerWidgetInitialized = 'true'
    new DrawerWidgetComponent(element)
  })
}

const autoInitDrawerWidgets = (): void => {
  if (typeof document === 'undefined') {
    return
  }

  if (!document.querySelector('[data-drawer-widget-component]')) {
    return
  }

  initDrawerWidgets(document)
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInitDrawerWidgets)
  } else {
    autoInitDrawerWidgets()
  }
}
